module.exports = __webpack_public_path__ + "static/media/Menu.f35db231.svg";